import { Company, Client, Agency } from 'Types';

type Props = {
  clients: Company[];
};

export const formatClients = ({ clients }: Props): Client[] => {
  return clients
    ? clients
        .flatMap((client) =>
          client.accounts.map((account) => ({
            id: client.id,
            name: client.name,
            label: `${client.name} (${
              account.codeTiers.startsWith('$') ? 'Prospect' : account.codeTiers
            })`,
            accountId: account.id,
            emails: client.users
              .filter(({ isActive }) => isActive)
              .map(({ email }) => email),
          })),
        )
        .filter((c) => c.emails.length > 0)
    : [];
};

export type CompanyData = {
  id: number;
  name: string;
  accounts: number;
  users: number;
  agency: Agency;
  tiers: string[];
};

export const formatCompaniesList = (companies: Company[]): CompanyData[] => {
  return companies.map(({ id, name, accounts, users }) => ({
    id,
    name,
    accounts: accounts.length,
    users: users.length,
    agency: accounts[0]?.agency,
    tiers: accounts.map((a) => a.codeTiers),
  }));
};
